module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"virtualTagsTable.noRecords":"There are no virtual tags configured for this service."}}')
  delete Component.options._Ctor
}
